export const getMenuItems = () => {
  // Items do menu ação
  return [{ key: "1", label: "Gerenciar Períodos" }];
};
